import React, {useState} from 'react';
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Helmet} from 'react-helmet';
import {setVerify} from '../../store/builder/forgotPasswordSlice';
import ReactCodeInput from 'react-code-input';
import {useTranslation} from '../../hooks/useTranslation';

export default function EnterCode() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [state, setState] = useState(null);
  const forgotData = useSelector(
    state => state.rootReducer.forgotPasswordSlice,
  );


  const handleCode = e => {
    setState(e);
  };

  const submitHandler = e => {
    e.preventDefault();
    if (state?.length === 6) {
      dispatch(setLoader(true));
      let body = {code: state, verify_token: forgotData.verifyToken};
      let config = {
        headers: {
          AppVersion: '1.0.0',
          AppType: 'web',
          DeviceType: 'web',
        },
      };
      axios
        .post(
          `${import.meta.env.VITE_API_URL}auth/verify-reset-password`,
          body,
          config,
        )
        .then(res => {
          dispatch(setVerify(res?.data?.data?.verify_token));
          navigate('/create-password');
          dispatch(setLoader(false));
          toast.success(res.data.message);
        })
        .catch(err => {
          dispatch(setLoader(false));
          toast.error(err.response.data.message);
        });
    } else {
              toast.error(t('enterCode.enterValidCode'));
    }
  };
  const inputStyle = {
    fontFamily: 'monospace',
    margin: '4px',
    padding: '12px',
    width: '65px',
    height: '63px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    textAlign: 'center',
    fontSize: '16px',
  };

  return (
    <div className='auth'>
      <Helmet>
        <title>{t('enterCode.pageTitle')}</title>
      </Helmet>
      <div className='auth__wrapper'>
        <div className='auth__left'>
          <img src='/assets/forgot-image.png' alt='bg' />
        </div>
        <div className='auth__right'>
          <div className='auth__content forgot'>
            <h1 className='auth__title'>{t('enterCode.title')}</h1>
            <p className='auth__subtitle'>
                              {t('enterCode.subtitle', {email: forgotData?.email})}
            </p>
            <form className='auth__form' onSubmit={submitHandler}>
              <div className='auth__field'>
                <ReactCodeInput
                  className='auth__field-codeField'
                  onChange={handleCode}
                  fields={6}
                  inputStyle={inputStyle}
                />
                {state?.email?.errorShow && (
                  <span className='auth__error'>{state?.email?.error}</span>
                )}
              </div>
                              <button className='auth__submit'>{t('enterCode.verify')}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
